<script>
import UploadPopover from "@/components/widgets/upload-popover.vue";
import Swal from "sweetalert2";
export default {
    name: "BacklogModal",
    props: {
        wActions: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "Uploaded Files",
        },
        header: String,
        subheader: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        UploadPopover,
    },
    data(){
        return {
            tableData: [],
            filter: "",
            attachmentLoading: false,
            attachmentId: 0,
            attachmentPV: false,
            uploadOpt: {}
        }
    },
    computed: {
        filteredItems(){
            let data = this.tableData;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data;
        },
    },
    methods: {
        async getData(id){
            this.attachmentId = id;
            this.tableData = [];
            this.attachmentLoading = true;
            await this.$store
                .dispatch("filemanager/GetFiles", {id: id, type: this.uploadOpt.type, removeLoading: true})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.tableData = res.data;
                })
                .catch(() => {
                    this.showToast('Something went wrong! - getting documents', "error");
                });
            this.attachmentLoading = false;
        },
        async getMultipleData(types, id){
            this.attachmentId = id;
            this.tableData = [];
            let tabData = [];
            this.attachmentLoading = true;
            for await (const type of types) {
                await this.$store
                    .dispatch("filemanager/GetFiles", {id: type.id, type: type.type, removeLoading: true})
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        tabData = tabData.concat(res.data);
                    })
                    .catch(() => {
                        this.showToast('Something went wrong! - getting documents', "error");
                    });
            }
            this.tableData = tabData;
            this.attachmentLoading = false;
        },
        getCount(){
            return this.tableData.length;
        },
        setUploadOpt(opt){
            this.uploadOpt = opt;
        },
        uploadedDocument(response) {
            this.tableData.push(response);
        },
        removeFile(id) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("filemanager/DeleteFile", id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = this.tableData.findIndex(item => item.id == id);
                            this.tableData.splice(index, 1);
                            this.showToast('Successfully removed!', "success");
                        })
                        .catch(() => {
                            this.showToast('Cannot be remove!', "error");
                        });
                }
            });
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        dropCount(){
            this.$emit('dropCount', this.tableData.length);
            this.$emit('dropAttachmentData', this.tableData);
            this.$bvModal.hide('upload-attachment-modal');
        },
    }
}
</script>
<template>
    <b-modal
        id="upload-attachment-modal"
        :title="title"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        @close="dropCount"
    >
        <h5 class="mb-1" v-if="header">{{header}}</h5>
        <h6 class="mb-4" v-if="subheader && subheader.title" :class="[subheader.class]">{{subheader.title}}</h6>
        <div class="row">
            <div class="col-md-6">
                <input type="search" class="form-control form-control" placeholder="Search Attachments" v-model="filter">
            </div>
            <div class="col-md-6 text-right">
                <div v-if="wActions">
                    <b-button variant="success" @click="attachmentPV = true"  :id="`target-attachment-${attachmentId}`">
                        <i class="fa fa-upload"></i> Upload
                    </b-button>
                    <upload-popover
                        :option="
                            uploadOpt
                        "
                        :sourceId="
                            attachmentId
                        "
                        @uploaded="
                            uploadedDocument(
                                $event
                            )
                        "
                        :showPV="
                            attachmentPV
                        "
                        @closePopover="attachmentPV = false"
                        :dzId="`dropzone-target${attachmentId}`"
                        :pvId="`target-attachment-${attachmentId}`"
                    ></upload-popover>
                </div>
            </div>
        </div>
        <div>
            <h5 class="mt-3" v-if="!attachmentLoading && tableData.length == 0"> No document found.</h5>
            <h5 class="mt-3" v-if="!attachmentLoading && tableData.length > 0 && filteredItems.length == 0 && filter"> Search not found.</h5>
        </div>
        <div
            class="
                d-flex
                justify-content-center
                align-items-center
                ms-4
                font-size-14
                mt-4
            "
            v-if="attachmentLoading"
        >
            <div
                class="
                    preloader-component
                    me-2
                "
            >
                <div
                    class="
                        status
                    "
                >
                    <div
                        class="
                            spinner-chase
                            w-20px
                            h-20px
                        "
                    >
                        <div
                            class="
                                chase-dot
                            "
                        ></div>
                        <div
                            class="
                                chase-dot
                            "
                        ></div>
                        <div
                            class="
                                chase-dot
                            "
                        ></div>
                        <div
                            class="
                                chase-dot
                            "
                        ></div>
                        <div
                            class="
                                chase-dot
                            "
                        ></div>
                        <div
                            class="
                                chase-dot
                            "
                        ></div>
                    </div>
                </div>
            </div>
            <strong
                >Loading...</strong
            >
        </div>
        <div class="row" v-if="tableData.length > 0 && !attachmentLoading">
            <div class="col-md-6" v-for="y in filteredItems" :key="y.id">
                <div
                    class="
                        position-relative
                        cursor-pointer
                        border
                        mt-2
                        br-5
                    "
                >
                    <div
                        class="
                            border
                            p-3
                        "
                    >
                        <div>
                            <div
                                class="
                                    float-end
                                    ms-2
                                "
                            >
                                <b-dropdown
                                    id="dropdown-dropleft"
                                    right
                                    variant="link"
                                    toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                    menu-class="dropdown-menu-end"
                                    no-caret
                                >
                                    <template #button-content>
                                        <i class="mdi mdi-dots-horizontal"></i>
                                    </template>
                                    <b-dropdown-item
                                        @click="openDocument(y)"
                                        ><i class="bx bx-link-external me-1"></i>Open</b-dropdown-item
                                    >
                                    <b-dropdown-item variant="danger" @click="removeFile(y.id)" v-if="wActions"
                                        ><i class="bx bx-trash me-1"></i>Remove</b-dropdown-item
                                    >
                                </b-dropdown>
                            </div>
                            <div
                                class="
                                    avatar-xs
                                    me-3
                                    mb-2
                                "
                                @click="openDocument(y)"
                            >
                                <div
                                    class="
                                        avatar-title
                                        bg-transparent
                                        rounded
                                    "
                                >
                                    <i
                                        v-if="y.fileType.includes('image')"
                                        class="
                                            mdi mdi-image
                                            font-size-24
                                            text-purple
                                        "
                                    ></i>
                                    <i
                                        v-if="y.fileType.includes('application')"
                                        class="
                                            mdi mdi-file-pdf-outline
                                            font-size-24
                                            text-danger
                                        "
                                    ></i>
                                </div>
                            </div>
                            <div
                                class="
                                    d-flex
                                "
                                @click="openDocument(y)"
                            >
                                <div
                                    class="
                                        overflow-hidden
                                        me-auto
                                    "
                                >
                                    <h5
                                        class="
                                            font-size-14
                                            text-truncate
                                            mb-1
                                        "
                                    >
                                        {{y.description}}
                                    </h5>
                                    <p
                                        class="
                                            text-muted
                                            mb-0
                                        "
                                    >
                                        {{formatDateWithTime(new Date(y.dateTimeUploaded))}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>